import { render, staticRenderFns } from "./BoxVersionsSelect.vue?vue&type=template&id=200df922&scoped=true&"
import script from "./BoxVersionsSelect.vue?vue&type=script&lang=js&"
export * from "./BoxVersionsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200df922",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200df922')) {
      api.createRecord('200df922', component.options)
    } else {
      api.reload('200df922', component.options)
    }
    module.hot.accept("./BoxVersionsSelect.vue?vue&type=template&id=200df922&scoped=true&", function () {
      api.rerender('200df922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BoxVersionsSelect.vue"
export default component.exports